<template>
  <router-view />
</template>

<script>
export default {
  name: 'hmRouterView'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/layout/routerView.vue